/**
 * CODE
 */

/**
 * I subscribe service worker to receive push notifications.
 *
 * :param pushManager: push api interface
 *
 * :returns: push subscription
 */
async function subscribe(
    pushManager: PushManager,
    publicKey: string,
): Promise<PushSubscription | null>
{
    return await pushManager?.subscribe({
        applicationServerKey: urlBase64ToUint8Array(publicKey),
        userVisibleOnly: true,
    }) ?? null;
}


/**
 * I convert urlBase64 to Uint8Array.
 *
 * :param base: base to be converted
 *
 * :returns: converted base to Uint8Array
 */
function urlBase64ToUint8Array(base: string): Uint8Array
{
    // pad base and replace characters
    const padding = '='.repeat((4 - base.length % 4) % 4);
    const base64 = (base + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    // decode base-64
    const rawData = window.atob(base64);

    // create result instance
    const outputArray = new Uint8Array(rawData.length);

    // assign values to final result
    for (let i = 0; i < rawData.length; ++i)
    {
        outputArray[i] = rawData.charCodeAt(i);
    }

    // return converted base
    return outputArray;
}


/**
 * EXPORTS
 */
export
{
    subscribe,
};
